import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Plugin } from './plugin'
import type { State } from './state'

/**
 * Core actions for this {@link Plugin}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig<
  TTypeParams extends ec.models.TypeParams.Constraint,
>(collection: ec.Collection<TTypeParams>) {
  return {
    /* eslint-disable sort-keys */
    /**
     * Jumps to the desired page of data
     */
    changePage: store.actions.standalone({
      data: ({
        next,
        page,
        previous,
      }: ExactlyOneOf<{
        readonly next: true
        readonly previous: true
        readonly page: number
      }>) => ({ next, previous, page }),
    }),
    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
